import React from 'react';
import { hasPermission } from '../Utils/role';

const RoleGuard = ({ requiredPermission, children, fallback = null }) => {
    if (hasPermission(requiredPermission)) {
        return <>{children}</>;
    }

    return fallback;
};

export default RoleGuard;